import type { UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import type { MarkOrderSettledArgs, Order } from '@ztechapps/common.contract'
import { ORDER_MARK_SETTLED_MUTATION } from './graphql'

/**
 * Records a real on-account settlement for an order's open balance via the
 * `orderMarkSettled` action. The server posts an onAccount paid payment for the
 * current balance so the order becomes Fully Paid and leaves AR — replacing the
 * legacy fake-cash workaround. The acting user is injected server-side.
 */
export const useMarkOrderSettled = ({ query, ...props } = {} as UseMutationProps) => {
  return useActionMutation<Order, MarkOrderSettledArgs>({
    query: query ?? ORDER_MARK_SETTLED_MUTATION,
    ...props,
  })
}
